import { render, staticRenderFns } from "./AddEditFormGroup.vue?vue&type=template&id=ff6b72e2&scoped=true"
import script from "./AddEditFormGroup.vue?vue&type=script&lang=js"
export * from "./AddEditFormGroup.vue?vue&type=script&lang=js"
import style0 from "./AddEditFormGroup.vue?vue&type=style&index=0&id=ff6b72e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6b72e2",
  null
  
)

export default component.exports